import React, { useState } from 'react';
import { profile, highlights } from '../data/content';

export default function Hero() {
  const [photoError, setPhotoError] = useState(false);
  const photoUrl = process.env.PUBLIC_URL + (profile.photo || '/profile.jpg');

  return (
    <header className="hero" id="hero">
      <div className="hero__content">
        <div className="hero__photo-wrap">
          {!photoError && profile.photo ? (
            <img
              src={photoUrl}
              alt={profile.name}
              className="hero__photo"
              style={{ objectPosition: profile.photoPosition || '50% 35%' }}
              onError={() => setPhotoError(true)}
            />
          ) : (
            <div className="hero__photo hero__photo--initials" aria-hidden="true">
              {profile.name.split(' ').map((n) => n[0]).join('')}
            </div>
          )}
        </div>
        <p className="hero__label">Mobile Software Engineer</p>
        <h1 className="hero__name">{profile.name}</h1>
        <p className="hero__tagline">
          Building production iOS & Android apps at scale — ride-hailing, fintech, real-time systems.
        </p>
        <div className="hero__highlights">
          {highlights.map((item) => (
            <span key={item} className="hero__pill">{item}</span>
          ))}
        </div>
        <div className="hero__cta">
          <a href="#contact" className="hero__btn hero__btn--primary">Get in touch</a>
          <a href={profile.github} target="_blank" rel="noopener noreferrer" className="hero__btn hero__btn--outline">GitHub</a>
        </div>
      </div>
    </header>
  );
}
